// SessionExpiredModal.js
import React from 'react';
import PropTypes from 'prop-types';

const SessionExpiredModal = ({ isOpen, onClose, onLogin }) => {
  if (!isOpen) return null; // Don't render anything if modal is closed

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-4">
        <h2 className="text-lg font-bold">Session Expired</h2>
        <p>Your session has expired. Please log in again.</p>
        <div className="flex justify-end mt-4">
          <button className="mr-2" onClick={onClose}>
            Cancel
          </button>
          <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={onLogin}>
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

SessionExpiredModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default SessionExpiredModal;
